import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseUtils, FuseAnimate} from '@fuse';
import {bindActionCreators} from 'redux';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxVip from '../../../../store/actionreducers/vip';
import ReduxCompany from '../../../../store/actionreducers/company';
import ReactTable from "react-table";
import classNames from 'classnames';
import _ from 'lodash';
import {
    Avatar,
    Typography,
    Checkbox,
    Button
} from '@material-ui/core';
import {UploadButton} from "../../../../components";
import UecareStatus from "../../../../components/UecareStatus";
import {constDataDialogs} from "../../../../constants";


const styles = theme => ({
    mailList: {
        padding: 0
    },
    mailItem: {},
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    button: {
        marginLeft: theme.spacing.unit,
    },
    csvButton: {
        backgroundColor: '#F44336'
    },
});

class CompanyVipList extends Component {

    state = {
        filterUsageData: [],
        is_csv_uploaded: false,
    };

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    onFilteredChange = (filtered) => {
        const currentRecords = this.selectTable.getResolvedState().sortedData;
        this.setState({filterUsageData: _.map(currentRecords, '_original')});
    };

    openSelectedContactMenu = (event) => {
        this.setState({selectedContactsMenu: event.currentTarget});
    };

    closeSelectedContactsMenu = () => {
        this.setState({selectedContactsMenu: null});
    };

    joinVipsButtonShow = () => {
        return this.props.company.id && this.props.selectedVipIds.length > 0;
    };

    render() {
        const {
            classes, vips, searchText, company, selectedVipIds, joinNewVips,
            openAlertDialog, getVip, setVip, getCompanyVips, joinVips, convertCsvToVips,
            selectAllContacts, deSelectAllContacts, toggleInSelectedContact, openDataDialog,
        } = this.props;

        const template_csv_url = 'https://res.cloudinary.com/uecare/raw/upload/v1550500663/oriact/%E5%85%AC%E5%8F%B8%E6%9C%83%E5%93%A1%E4%B8%8A%E5%82%B3%E6%A0%BC%E5%BC%8F.xlsx';

        const data = this.getFilteredArray(vips, searchText);

        if (!data && data.length === 0) {
            return (
                <div className="flex items-center justify-center h-full">
                    <Typography color="textSecondary" variant="headline">
                        目前沒有任何會員
                    </Typography>
                </div>
            );
        }

        return (
            <div>
                <div className="flex items-center justify-between pb-8">
                    <FuseAnimate animation="transition.slideLeftIn" delay={500}>
                        <div className="flex items-center">
                            <FuseAnimate animation="transition.slideLeftIn" delay={500}>
                                <Typography>{`總共 ${this.state.filterUsageData.length === 0 ? data.length : this.state.filterUsageData.length} 筆資料`}</Typography>
                            </FuseAnimate>
                        </div>
                    </FuseAnimate>

                    <FuseAnimate animation="transition.slideLeftIn" delay={500}>
                        <div>
                            {/*<Button variant="raised"*/}
                            {/*        className={classes.button}*/}
                            {/*        style={{display: (this.state.is_csv_uploaded) ? 'none' : ''}}*/}
                            {/*        color="secondary"*/}
                            {/*        onClick={async () => {*/}
                            {/*            try {*/}
                            {/*                const vips = await getVips();*/}
                            {/*                await setCompanyVips(vips);*/}
                            {/*            } catch (e) {*/}
                            {/*                console.warn('you got an error = ', e);*/}
                            {/*            }*/}
                            {/*        }}>*/}
                            {/*    所有*/}
                            {/*</Button>*/}
                            {/*<Button variant="raised"*/}
                            {/*        className={classes.button}*/}
                            {/*        style={{display: (this.state.is_csv_uploaded) ? 'none' : ''}}*/}
                            {/*        color="secondary"*/}
                            {/*        onClick={async () => {*/}
                            {/*            try {*/}
                            {/*                await getCompanyVips(company.id);*/}
                            {/*            } catch (e) {*/}
                            {/*                console.warn('you got an error = ', e);*/}
                            {/*            }*/}
                            {/*        }}>*/}
                            {/*    公司*/}
                            {/*</Button>*/}
                            {
                                (this.props.company.id) ? (
                                    <UploadButton
                                        label='上傳 CSV'
                                        name='uploadCsv'
                                        id='uploadCsv'
                                        variant="raised"
                                        color="secondary"
                                        className={classNames(classes.button)}
                                        onClick={(jsonData) => {
                                            this.setState({is_csv_uploaded: !this.state.is_csv_uploaded, jsonData});
                                            convertCsvToVips(jsonData);
                                        }}/>
                                ) : ''
                            }
                            {
                                (this.props.company.id) ? (
                                    <Button variant="contained"
                                            className={classNames(classes.button, classes.csvButton)}
                                            color="secondary"
                                            style={{backgroundColor:"#e660bb"}}
                                            onClick={()=>{
                                                window.open(template_csv_url,'_blank');
                                            }}>
                                        CSV格式下載
                                    </Button>
                                ) : ''
                            }
                            <Button variant="raised"
                                    className={classNames(classes.button, classes.csvButton)}
                                    color="primary"
                                    style={{display: (this.joinVipsButtonShow()) ? '' : 'none'}}
                                    onClick={async () => {
                                        try {
                                            (this.state.is_csv_uploaded) ?
                                                await joinNewVips({companyId: company.id, vips}) :
                                                await joinVips({companyId: company.id, vipIds: selectedVipIds});
                                            await getCompanyVips(company.id);
                                            deSelectAllContacts();
                                        } catch (e) {
                                            console.warn('you got an error = ', e);
                                        }
                                    }}>
                                將選到的VIP加入{company && company.name}
                            </Button>
                        </div>
                    </FuseAnimate>
                </div>

                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <ReactTable
                        previousText='Previous'
                        nextText='Next'
                        loadingText='Loading...'
                        noDataText="目前沒有任何會員"
                        pageText='頁'
                        ofText='/共'
                        rowsText='筆'
                        defaultPageSize={10}
                        className={classNames(classes.root, "-striped -highlight")}
                        ref={r => this.selectTable = r}
                        onFilteredChange={this.onFilteredChange}
                        getTrProps={(state, rowInfo, column) => {
                            return {
                                className: "cursor-pointer",
                                onClick: async (e, handleOriginal) => {

                                    try {
                                        if (!(company && company.id)) {
                                            // company not exist

                                            const alertDialogInfo = {
                                                title: '尚未選擇企業',
                                                message: '您需要先選擇一個企業 , 才能編輯 VIP 資料',
                                                yesButton: {label: '了解'},
                                                noButton: {label: ''}
                                            };

                                            openAlertDialog(alertDialogInfo);

                                        } else if (rowInfo) {
                                            const vipId = rowInfo.original.id;
                                            (vipId) ? await getVip(vipId) : setVip(rowInfo.original);
                                            openDataDialog({
                                                type: constDataDialogs.type.edit,
                                                name: constDataDialogs.name.vipDialog
                                            }); // 打開 vipDialog
                                        }

                                    } catch (e) {
                                        console.warn('you got an error = ', e);
                                    }
                                }
                            }
                        }}
                        data={
                            data.sort(function (preVip, currVip) {
                                return currVip.id - preVip.id;
                            })
                        }
                        columns={[
                            {
                                Header: () => (
                                    <Checkbox
                                        onClick={(event) => {
                                            event.stopPropagation();
                                        }}
                                        onChange={(event) => {
                                            event.target.checked ? selectAllContacts(vips) : deSelectAllContacts();
                                        }}
                                        checked={selectedVipIds.length === Object.keys(vips).length && selectedVipIds.length > 0}
                                        indeterminate={selectedVipIds.length !== Object.keys(vips).length && selectedVipIds.length > 0}
                                    />
                                ),
                                accessor: "",
                                Cell: row => {
                                    return (
                                        <Checkbox
                                            onClick={(event) => {
                                                event.stopPropagation();
                                            }}
                                            checked={selectedVipIds.includes(row.value.id)}
                                            onChange={() => toggleInSelectedContact(row.value.id)}
                                        />
                                    )
                                },
                                className: "justify-center",
                                sortable: false,
                                width: 64
                            },
                            {
                                Header: "頭像",
                                width: 64,
                                accessor: "user.avatar.url",
                                Cell: row => {
                                    return (<Avatar className="mr-8" alt={row.original.user.name} src={row.value}/>);
                                },
                                className: "justify-center",
                                sortable: false
                            },
                            {
                                Header: "姓名",
                                accessor: "user.name",
                                filterable: true,
                                className: "font-bold"
                            },
                            {
                                Header: "暱稱",
                                accessor: "user.nickname",
                                filterable: true,
                                className: "font-bold",
                                width: 100,
                            },
                            {
                                Header: "會員編號",
                                accessor: "vip_card_no",
                                filterable: true,
                                width: 150,
                            },
                            {
                                Header: "Email",
                                accessor: "user.email",
                                filterable: true
                            },
                            {
                                Header: "狀態",
                                accessor: "status",
                                Cell: row => {
                                    if (row.value && row.value.label) {
                                        return <UecareStatus name={row.value.name} label={row.value.label}/>;
                                    } else return '';
                                },
                                filterable: true,
                                className: "items-center justify-center",
                                width: 100,
                            },
                            // {
                            //     Header: () => <div>加入<br/>益友</div>,
                            //     width: 64,
                            //     Cell: row => {
                            //         if (row.original.status.label === 'applying' ||
                            //             row.original.status.label === 'validateFail' ||
                            //             row.original.status.label === 'disable') {
                            //             return (
                            //                 <div className="flex items-center">
                            //                     <IconButton
                            //                         onClick={async (ev) => {
                            //                             try {
                            //                                 ev.stopPropagation();
                            //                                 const vipId = row.original.id;
                            //                                 await getVip(vipId);
                            //                                 openDataDialog({
                            //                                     type: constDataDialogs.type.new,
                            //                                     name: constDataDialogs.name.joinClubDialog
                            //                                 }); // 打開加入益友頁
                            //                             } catch (e) {
                            //                                 console.warn('you got an error = ', e);
                            //                             }
                            //                         }}
                            //                     >
                            //                         <Icon>verified_user</Icon>
                            //                     </IconButton>
                            //                 </div>
                            //             );
                            //         } else return '';
                            //     }
                            // },
                            // {
                            //     Header: "停用",
                            //     width: 64,
                            //     Cell: row => {
                            //         if (row.original.status.label !== 'enable') return '';
                            //         else return (
                            //             <div className="flex items-center">
                            //                 <IconButton
                            //                     onClick={(ev) => {
                            //                         ev.stopPropagation();
                            //
                            //                         const vip = row.original;
                            //
                            //                         const alertDialogInfo = {
                            //                             title: '停用帳號',
                            //                             message: `請問您要停用帳號(${vip.user.name})嗎?`,
                            //                             yesButton: {
                            //                                 label: '是',
                            //                                 onClick: async () => {
                            //                                     try {
                            //                                         openLoadingMask();
                            //                                         await disableVip(vip.id);
                            //                                         await getVips();
                            //                                         closeLoadingMask();
                            //                                     } catch (e) {
                            //                                         console.warn('you got an error = ', e);
                            //                                     }
                            //                                 },
                            //                             },
                            //                             noButton: {label: '否'}
                            //                         };
                            //
                            //                         openAlertDialog(alertDialogInfo); // disable VIP
                            //                     }}
                            //                 >
                            //                     <Icon>delete</Icon>
                            //                 </IconButton>
                            //             </div>
                            //         );
                            //     }
                            // },
                            // {
                            //     Header: () => <div>點數<br/>操作</div>,
                            //     width: 64,
                            //     filterable: false,
                            //     Cell: row => (
                            //         <div className="flex items-center">
                            //             <IconButton
                            //                 onClick={async (ev) => {
                            //                     try {
                            //                         ev.stopPropagation();
                            //                         const vipId = row.original.id;
                            //                         await getVip(vipId);
                            //                         openDataDialog({
                            //                             type: constDataDialogs.type.new,
                            //                             name: constDataDialogs.name.useRecordDialog
                            //                         }); // 打開點數操作頁
                            //                     } catch (e) {
                            //                         console.warn('you got an error = ', e);
                            //                     }
                            //                 }}
                            //             >
                            //                 <Icon>monetization_on</Icon>
                            //             </IconButton>
                            //         </div>
                            //     )
                            // }
                        ]}
                    />
                </FuseAnimate>
            </div>

        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getVips: ReduxVip.ActionCreator.getVips,
        getVip: ReduxVip.ActionCreator.getVip,
        setVip: ReduxVip.ActionCreator.setVip,
        setCompanyVips: ReduxVip.ActionCreator.setCompanyVips,
        getCompanyVips: ReduxVip.ActionCreator.getCompanyVips,
        disableVip: ReduxVip.ActionCreator.disableVip,
        convertCsvToVips: ReduxVip.ActionCreator.convertCsvToVips,
        joinVips: ReduxCompany.ActionCreator.joinVips,
        joinNewVips: ReduxCompany.ActionCreator.joinNewVips,
        selectAllContacts: ReduxGlobal.ActionCreator.selectAllContacts,
        deSelectAllContacts: ReduxGlobal.ActionCreator.deSelectAllContacts,
        toggleInSelectedContact: ReduxGlobal.ActionCreator.toggleInSelectedContact,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        openEditDataDialog: ReduxGlobal.ActionCreator.openEditDataDialog,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        openSecondDataDialog: ReduxGlobal.ActionCreator.openSecondDataDialog,
        openThirdDataDialog: ReduxGlobal.ActionCreator.openThirdDataDialog,
    }, dispatch);
}

function mapStateToProps({global: {searchText, selectedContactIds}, company: {company}, vip: {companyVips}}) {
    return {vips: companyVips, searchText, selectedVipIds: selectedContactIds, company}
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyVipList)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/companyVip/CompanyVipList.js